import { Component, ViewEncapsulation } from '@angular/core';
import { DDatosCompartidosCabecera } from '@dian-cmp/formulario';


@Component({
  selector: 'app-contenedor-formulario',
  templateUrl: './contenedor-formulario.component.html',
  styleUrls: ['./contenedor-formulario.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ContenedorFormularioComponent {

  public dDatosCompartidosCabecera: DDatosCompartidosCabecera;
    
    constructor () {
    	this.dDatosCompartidosCabecera = new DDatosCompartidosCabecera();
    }

}



// WEBPACK FOOTER //
// D:/350/v5/ng_retefuente350v5/Front_formReteFuente350v5/src/app/components/formulario/contenedor-formulario/contenedor-formulario.component.ts